import styled from 'styled-components';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';

export default styled(SlideDown)`
  transition-duration: 300;
  transition-timing-function: cubic-bezier(0.1, 0.7, 1, 0.1);
`;
